// Copyright (c) 2015, Frappe Technologies Pvt. Ltd. and Contributors
// License: GNU General Public License v3. See license.txt
// shopping cart
frappe.provide("erpnext.e_commerce.shopping_cart");
var shopping_cart = erpnext.e_commerce.shopping_cart;
const style = document.createElement('style');
style.innerHTML = `
.loader, .loader:before, .loader:after {
	border-radius: 50%;
	width: 2.5em;
	height: 2.5em;
	animation-fill-mode: both;
	animation: bblFadInOut 1.8s infinite ease-in-out;
}
.loader {
	color: #FFF;
	font-size: 7px;
	position: relative;
	text-indent: -9999em;
	transform: translateZ(0);
	animation-delay: -0.16s;
}
.loader:before,
.loader:after {
	content: '';
	position: absolute;
	top: 0;
}
.loader:before {
	left: -3.5em;
	animation-delay: -0.32s;
}
.loader:after {
	left: 3.5em;
}
@keyframes bblFadInOut {
	0%, 80%, 100% { box-shadow: 0 2.5em 0 -1.3em }
	40% { box-shadow: 0 2.5em 0 0 }
}
`;
document.head.appendChild(style);

function sync_rodin_navbar_cart_badges(display_count, animate) {
	var n = parseInt(String(display_count), 10);
	if (isNaN(n) || n < 0) {
		n = 0;
	}
	var show = n > 0;
	var badgeNodes = document.querySelectorAll("[data-rodin-cart-badge]");
	for (var i = 0; i < badgeNodes.length; i++) {
		var el = badgeNodes[i];
		el.textContent = show ? String(n) : "";
		el.classList.toggle("rodin-nav-cart-badge--empty", !show);
		el.setAttribute("aria-hidden", show ? "false" : "true");
	}
	if (animate && show) {
		var wraps = document.querySelectorAll("[data-rodin-cart-animate]");
		for (var j = 0; j < wraps.length; j++) {
			(function (w) {
				w.classList.add("rodin-nav-cart-pulse");
				setTimeout(function () {
					w.classList.remove("rodin-nav-cart-pulse");
				}, 500);
			})(wraps[j]);
		}
	}
}

var getParams = function (url) {
	var params = {};
	var parser = document.createElement("a");
	parser.href = url;
	var query = parser.search.substring(1);
	if (!query) {
		return params;
	}
	var vars = query.split("&");
	for (var i = 0; i < vars.length; i++) {
		if (!vars[i]) {
			continue;
		}
		var pair = vars[i].split("=");
		var key = pair[0];
		if (!key) {
			continue;
		}
		var rawVal = pair.length > 1 ? pair.slice(1).join("=") : "";
		try {
			params[key] = decodeURIComponent(rawVal.replace(/\+/g, " "));
		} catch (e) {
			params[key] = rawVal;
		}
	}
	return params;
};



function showLoader() {
	if (window.location.pathname === "/cart")
		return;

	var loaderContainer = document.createElement('div');
	loaderContainer.style.position = 'fixed';
	loaderContainer.style.top = '0';
	loaderContainer.style.left = '0';
	loaderContainer.style.width = '100%';
	loaderContainer.style.height = '100%';
	loaderContainer.style.display = 'flex';
	loaderContainer.style.justifyContent = 'center';
	loaderContainer.style.alignItems = 'center';
	loaderContainer.style.zIndex = '9999';
	loaderContainer.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';

	var button = document.createElement('button');
	button.className = 'd-flex align-items-center px-3';
	button.type = 'button';
	button.disabled = true;
	button.style.backgroundColor = '#373737';
	button.style.opacity = '60%';
	button.style.fontSize = '24px';
	button.style.color = 'white';
	button.style.flexDirection = 'row-reverse';




	var spinner = document.createElement('span');
	spinner.className = 'spinner-border spinner-border-sm ml-2'; // فاصله‌ی راست با متن
	spinner.setAttribute('role', 'status');
	spinner.setAttribute('aria-hidden', 'true');

	var text = document.createElement('span');
	text.innerText = ' ...درحال بروزرسانی سبد خرید';

	button.appendChild(spinner);
	button.appendChild(text);
	loaderContainer.appendChild(button);
	document.body.appendChild(loaderContainer);

	document.body.style.pointerEvents = 'none';
}

// Method to hide the loader and enable user interactions
function hideLoader() {
	if (window.location.pathname === "/cart")
		return;
	// Remove the loader container from the body
	var loaderContainer = document.querySelector('div[style*="position: fixed"]');
	if (loaderContainer) {
		loaderContainer.remove();
	}

	// Enable user interactions
	document.body.style.pointerEvents = 'auto';
}

// Helper function to get Najva token
async function getNajvaToken() {
	try {
		// Check cache first
		let token = sessionStorage.getItem('najva_token');
		if (token) return token;

		// wait for Najva script to load
		if (!window.NAJVA || typeof window.NAJVA.getUserToken !== 'function')
			return null;

		token = await window.NAJVA.getUserToken();

		if (token) {
			sessionStorage.setItem('najva_token', token);
			return token;
		}

		console.log('[NAJVA] token: ', token);

		return null;
	} catch (err) {
		console.error(err);
		return null;
	}
}

frappe.ready(function () {
	// Run first: referral URL parsing can throw on odd query strings and would skip badge sync.
	try {
		shopping_cart.show_shoppingcart_dropdown();
		shopping_cart.set_cart_count();
		shopping_cart.show_cart_navbar();
	} catch (e) {
		console.warn("[shopping_cart] cart badge / dropdown init:", e);
	}

	var full_name = frappe.session && frappe.session.user_fullname;
	// update user
	if (full_name) {
		$('.navbar li[data-label="User"] a')
			.html('<i class="fa fa-fixed-width fa fa-user"></i> ' + full_name);
	}
	// set coupon code and sales partner code

	var url_args = getParams(window.location.href);

	var referral_coupon_code = url_args['cc'];
	var referral_sales_partner = url_args['sp'];

	var d = new Date();
	// expires within 30 minutes
	d.setTime(d.getTime() + (0.02 * 24 * 60 * 60 * 1000));
	var expires = "expires=" + d.toUTCString();
	if (referral_coupon_code) {
		document.cookie = "referral_coupon_code=" + referral_coupon_code + ";" + expires + ";path=/";
	}
	if (referral_sales_partner) {
		document.cookie = "referral_sales_partner=" + referral_sales_partner + ";" + expires + ";path=/";
	}
	referral_coupon_code = frappe.get_cookie("referral_coupon_code");
	referral_sales_partner = frappe.get_cookie("referral_sales_partner");

	if (referral_coupon_code && $(".tot_quotation_discount").val() == undefined) {
		$(".txtcoupon").val(referral_coupon_code);
	}
	if (referral_sales_partner) {
		$(".txtreferral_sales_partner").val(referral_sales_partner);
	}
});

$.extend(shopping_cart, {
	show_shoppingcart_dropdown: function () {
		$(".shopping-cart").on('shown.bs.dropdown', function () {
			if (!$('.shopping-cart-menu .cart-container').length) {
				return frappe.call({
					method: 'erpnext.e_commerce.shopping_cart.cart.get_shopping_cart_menu',
					callback: function (r) {
						if (r.message) {
							$('.shopping-cart-menu').html(r.message);
						}
					}
				});
			}
		});
	},

	update_cart: function (opts) {

		showLoader();

		if (frappe.session.user === "Guest") {
			if (localStorage) {
				localStorage.setItem("last_visited", window.location.pathname);
			}
			frappe.call('erpnext.e_commerce.api.get_guest_redirect_on_action').then((res) => {
				window.location.href = res.message || "/login";
			});
		} else {
			shopping_cart.freeze();

			// Get Najva token
			console.log('[NAJVA] Cart update initiated for item: ' + opts.item_code + ', qty: ' + opts.qty);

			// Helper function to make the cart update call
			function makeCartUpdateCall(najvaToken) {
				console.log('[NAJVA] Token status for cart update: ' + (najvaToken ? 'Present (length: ' + najvaToken.length + ')' : 'Missing'));
				if (najvaToken) {
					console.log('[NAJVA] Sending token with cart update:', najvaToken);
				} else {
					console.warn('[NAJVA] ⚠ No valid token available, webhook will be sent without token');
				}

				return frappe.call({
					type: "POST",
					method: "erpnext.e_commerce.shopping_cart.new_cart.add_item_cart",
					args: {
						item_code: opts.item_code,
						qty: opts.qty,
						additional_cost_items: opts.additional_cost_items,
						additional_notes: opts.additional_notes !== undefined ? opts.additional_notes : undefined,
						with_items: opts.with_items || 0,
						add: opts.add,
						najva_token: najvaToken || ""
					},
					headers: najvaToken ? {
						'X-Najva-Token': najvaToken
					} : {},
					btn: opts.btn,
					callback: function (r) {
						hideLoader();
						if (document.getElementById("g-total")) {
							const payable_total = (r.message['payable_total'] !== undefined) ? r.message['payable_total'] : r.message['grand_total'];
							document.getElementById("g-total").textContent = commafy(payable_total / 10);
							document.getElementById("n-total").textContent = commafy(r.message['net_total'] / 10);
							// document.getElementById("x-total").textContent=commafy(r.message['items_total']/10);
							document.getElementById("d-total").textContent = commafy(r.message['total_discount'] / 10);
							r.message['shipping_rules'].forEach(rule => {
								if (document.getElementById("amount-" + rule['name'])) {
									document.getElementById("amount-" + rule['name']).textContent = commafy(rule['amount'] / 10);
								}

							})
							if (r.message && r.message.wallet_amount === 0) {
								const walletRow = document.getElementById("wallet_amount-row");
								if (walletRow) {
									walletRow.remove();
								}
							}
							document.getElementById("shipping-amount").textContent = commafy(r.message['shippingAmount'] / 10);
							// Update price for both desktop and mobile (same id and id-mobile)
							var item_name = r.message['item_name'];
							[item_name, item_name + '-mobile'].forEach(function (id) {
								var el = document.getElementById(id);
								if (el) el.textContent = commafy(r.message['item_total'] / 10);
							});
							// Update quantity inputs (desktop and mobile)
							var inputEls = document.querySelectorAll(`input[data-item-code="${opts.item_code}"]`);
							inputEls.forEach(function (inputEl) {
								inputEl.value = r.message['item_qty'];
							});
							// Update no-discount price for both desktop and mobile
							var no_discount_id = r.message['item_name'] + "-no-discount";
							[no_discount_id, no_discount_id + '-mobile'].forEach(function (id) {
								var el = document.getElementById(id);
								if (el) el.textContent = commafy(r.message['item_total_no_discount'] / 10);
							});
							// Update discount percentage for both desktop and mobile
							var discount_perc = r.message['item_name'] + "-discount-perc";
							var discountPercText = commafy(
								Math.round(
									(1 - (r.message['item_total'] / r.message['item_total_no_discount'])) * 100
								)
							) + "%";
							[discount_perc, discount_perc + '-mobile'].forEach(function (id) {
								var el = document.getElementById(id);
								if (el) el.textContent = discountPercText;
							});


							if (document.getElementById("total_items")) {
								document.getElementById("total_items").textContent = commafy(r.message['total_qty']);
							}

							if (r.message['total_qty'] == 0) {
								location.reload();
							}
						}
						if (r.message["shipping_rules_list"]) {
							const shippingContainer = document.querySelector("#shipping-form");
							if (shippingContainer) {

								shippingContainer.innerHTML = ""; // clear old rules


								let checkboxes = [];

								// Build rows
								r.message["shipping_rules_list"].forEach(rule => {
									const row = document.createElement("div");
									row.className = "shipping-row d-flex flex-column align-items-start";

									row.innerHTML = `
            <div class="d-flex align-items-center w-100">
                <input type="checkbox"
                    id="${rule.name}"
                    class="shippingcheck"
                    name="shipping"
                    value="${rule.name}"
                    style="margin-right: 0 !important; margin-left: 4px !important;" />

                <div class="d-flex align-items-center justify-content-between w-100">
                    <label for="${rule.name}" style="margin: 0;">${rule.name || "بدون نام"}</label>
                    
                    <div class="d-flex" style="gap: 4px;">
                        <label class="text-left" id="amount-${rule.name}" for="${rule.name}">
                            ${rule.amount && rule.amount > 0 ? commafy(rule.amount / 10) : 0}
                        </label>
                        <span>تومان</span>
                    </div>
                </div>
            </div>
            ${rule.description ? `<p style="font-size: 14px; font-weight: 400; color: #212121ad; padding-right: 32px;">${rule.description}</p>` : ""}
        `;

									shippingContainer.appendChild(row);
								});

								checkboxes = shippingContainer.querySelectorAll(".shippingcheck");

								// === Selection Logic ===
								function applyRule(checkbox) {
									const shipping_name = checkbox.value;
									document.getElementById("shipping-rule-name").value = shipping_name;

									show_cart_loader();
									frappe.call({
										method: "erpnext.e_commerce.shopping_cart.new_cart.apply_shipping_rule",
										args: { shipping_name: shipping_name },
										callback: function (res) {
											if (res.message) {
												const payable_total = (res.message['payable_total'] !== undefined) ? res.message['payable_total'] : res.message['grand_total'];
												document.getElementById("g-total").textContent = commafy(payable_total / 10);
												document.getElementById("n-total").textContent = commafy(res.message['net_total'] / 10);
												document.getElementById("shipping-amount").textContent = commafy(res.message['shippingAmount'] / 10);
											}
											hide_cart_loader();
										}
									});
								}

								function setInitialRule() {
									let activeRule = (r.message["shipping_rules"] && r.message["shipping_rules"][0])
										? r.message["shipping_rules"][0]
										: null;

									let selected = null;

									checkboxes.forEach(cb => {
										if (activeRule && cb.value === activeRule) {
											cb.checked = true;
											selected = cb;
										} else {
											cb.checked = false;
										}
									});

									if (!selected && checkboxes.length > 0) {
										selected = checkboxes[0];
										selected.checked = true;
									}

									if (selected) applyRule(selected);
								}

								// Init selection
								setInitialRule();

								// Event listeners (radio button behavior)
								checkboxes.forEach(cb => {
									cb.addEventListener("change", function () {
										if (this.checked) {
											checkboxes.forEach(other => {
												if (other !== this) other.checked = false;
											});
											applyRule(this);
										}
									});
								});
							}
						}




						if (r.message["error"]) {
							frappe.msgprint({
								title: __('خطا'),
								indicator: 'red',
								message: r.message["error"],
								primary_action: {
									label: __('بستن'),
									action(values) {
										frappe.hide_msgprint();
									}
								}
							});
						}
						shopping_cart.unfreeze();
						shopping_cart.set_cart_count(true);
						if (opts.callback)
							opts.callback(r);
						hide_cart_loader();
					}
				});
			}

			// Get Najva token with .then() and proceed with cart update
			getNajvaToken().then(function (najvaToken) {
				return makeCartUpdateCall(najvaToken);
			}).catch(function (err) {
				console.warn('[NAJVA] ⚠ Error getting token, proceeding without token:', err);
				return makeCartUpdateCall(null);
			});
		}

	},

	set_cart_count: function (animate = false) {

		$(".intermediate-empty-cart").remove();

		var cart_count = frappe.get_cookie("cart_count");

		if (frappe.session.user === "Guest") {
			cart_count = 0;
		}

		if (cart_count) {
			$(".shopping-cart").toggleClass('hidden', false);
		}

		var $cart = $('.cart-icon');
		var $badge = $cart.find("#cart-count");
		// $badge.html(r.message.doc.total_qty);

		if ((parseInt(cart_count) === 0 || cart_count == undefined) && frappe.session.user != "Guest") {
			// $cart.css("display", "none");
			// $(".cart-tax-items").hide();
			// $(".btn-place-order").hide();
			// $(".cart-payment-addresses").hide();

			// let intermediate_empty_cart_msg = `
			// 	<div class="text-center w-100 intermediate-empty-cart mt-4 mb-4 text-muted">
			// 		${ __("Cart is Empty") }
			// 	</div>
			// `;
			// $(".cart-table").after(intermediate_empty_cart_msg);



			// frappe.call({
			// 	method: 'erpnext.e_commerce.shopping_cart.cart.get_cart_quotation',
			// 	callback: function(r) {
			// 		$cart.css("display", "inline");
			// 		$badge.html(r.message.doc.total_qty);
			// 		// $badge.html(r.message.doc.total_qty)
			// 	}
			// });



		}
		else {

			$cart.css("display", "inline");
			// $("#cart-count").text(cart_count);
			$badge.html(cart_count);



		}


		if (cart_count) {
			$badge.html(cart_count);

			if (animate) {
				$cart.addClass("cart-animate");
				setTimeout(() => {
					$cart.removeClass("cart-animate");
				}, 500);
			}
		}

		sync_rodin_navbar_cart_badges(cart_count, animate);

	},

	shopping_cart_update: function ({ item_code, qty, cart_dropdown, additional_notes, add = false }) {
		shopping_cart.update_cart({
			item_code,
			qty,
			additional_notes,
			with_items: 1,
			add: add,
			btn: this,
			callback: function (r) {
				function refresh_cart_multistep_sections() {
					// /cart is a multi-step UI: step-3 uses a separate "order summary" section.
					// After qty/remove updates in step-1, refresh step-3 sections from server.
					if (!(window.location && window.location.pathname === "/cart")) return;
					frappe.call({
						method: "erpnext.e_commerce.shopping_cart.cart.get_updated_cart_sections",
						args: {
							include_payment_summary: true,
							include_order_summary: true,
							include_payment_modes: false,
							include_shipping_rules: true,
							include_addresses: false
						},
						callback: function (sectionsRes) {
							if (sectionsRes && sectionsRes.message) {
								if (typeof shopping_cart.update_cart_sections === "function") {
									shopping_cart.update_cart_sections(sectionsRes.message);
								} else {
									// Fallback: update just the order summary if helper isn't available
									if (sectionsRes.message.order_summary) {
										var orderSummary = document.querySelector('.checkout-order-summary');
										if (orderSummary) orderSummary.innerHTML = sectionsRes.message.order_summary;
									}
								}
							}
						}
					});
				}

				if (r && !r.exc) {
					refresh_cart_multistep_sections();
				}

				if (qty == 0 && r.message['item_qty'] == 0) {
					const item_to_remove = document.querySelector(`tr[data-name="${r.message['item_name']}"]`)

					if (item_to_remove) {
						document.querySelector(`tr[data-name="${r.message['item_name']}"]`).remove();
					}
					else {
						const additional_item_to_remove = document.querySelector(`.remove-cart-item[data-item-code="${item_code}"]`)
						if (additional_item_to_remove) {
							document.querySelector(`.child-items[data-item-code="${item_code}"]`).remove();
						}

					}
					// show_cart_loader();
					// location.reload()
				}
				else {
					if (!r.exc) {
						$(".cart-items").html(r.message.items);
						$(".cart-tax-items").html(r.message.total);
						$(".payment-summary").html(r.message.taxes_and_totals);
						shopping_cart.set_cart_count();

						if (cart_dropdown != true) {
							$(".cart-icon").hide();
						}
					}
				}

			},
		});
	},

	show_cart_navbar: function () {
		// frappe.call({
		// 	method: "erpnext.e_commerce.doctype.e_commerce_settings.e_commerce_settings.is_cart_enabled",
		// 	callback: function(r) {
		// 		$(".shopping-cart").toggleClass('hidden', r.message ? false : true);
		// 	}
		// });
		$(".shopping-cart").toggleClass('hidden', false);
	},

	toggle_button_class(button, remove, add) {
		button.removeClass(remove);
		button.addClass(add);
	},

	bind_add_to_cart_action() {
		$('.page_content').on('click', '.btn-add-to-cart-list', (e) => {
			const $btn = $(e.currentTarget);
			$btn.prop('disabled', true);

			if (frappe.session.user === "Guest") {
				if (localStorage) {
					localStorage.setItem("last_visited", window.location.pathname);
				}
				frappe.call('erpnext.e_commerce.api.get_guest_redirect_on_action').then((res) => {
					window.location.href = res.message || "/login";
				});
				return;
			}

			$btn.addClass('hidden');
			$btn.closest('.cart-action-container').addClass('d-flex');
			$btn.parent().find('.go-to-cart').removeClass('hidden');
			$btn.parent().find('.go-to-cart-grid').removeClass('hidden');
			$btn.parent().find('.cart-indicator').removeClass('hidden');

			const item_code = $btn.data('item-code');
			erpnext.e_commerce.shopping_cart.update_cart({
				item_code,
				qty: 1
			});

		});
	},

	freeze() {
		if (window.location.pathname !== "/cart")
			return;
		show_cart_loader();
	},

	unfreeze() {
		if (window.location.pathname !== "/cart")
			return;
		hide_cart_loader();
	}
});

/* Rodin navbar cart badge: refresh after direct frappe.call cart APIs (e.g. WebsiteItem update_cart). */
$(document).on("ajaxComplete.rodinNavbarCartBadge", function (_ev, xhr, settings) {
	if (!xhr || xhr.status < 200 || xhr.status >= 300) return;
	var url = (settings && settings.url) ? String(settings.url) : "";
	if (url.indexOf("/api/method/") === -1) return;
	var path = url.split("?")[0];
	var sync =
		path.endsWith("erpnext.e_commerce.shopping_cart.new_cart.add_item_cart") ||
		path.endsWith("erpnext.e_commerce.shopping_cart.cart.update_cart");
	if (!sync) return;
	try {
		if (typeof shopping_cart !== "undefined" && shopping_cart.set_cart_count) {
			shopping_cart.set_cart_count(false);
		}
	} catch (e) {}
});

function commafy(num) {
	var str = num.toString().split('.');
	if (str[0].length >= 4) {
		str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, '$1,');
	}
	if (str[1] && str[1].length >= 4) {
		str[1] = str[1].replace(/(\d{3})/g, '$1 ');
	}
	return str.join('.');
}